module.exports = __webpack_public_path__ + "media/images/iconEdit__errorRed-1bf40447df83a9a64848cd414e4afee5.png";